import { Vault } from '../store/vaults';

const VAULTS_WHITELIST = 'https://raw.githubusercontent.com/ArrakisFinance/community-data/main/vaultsList.json'

export async function apiGetVaultsWhitelist(): Promise<Vault[]> {
  const response = await fetch(VAULTS_WHITELIST);
  const data = await response.json();
  return data.vaults as Vault[];
}